/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import { IconButton, Menu } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as Flags from 'country-flag-icons/react/3x2';
import React, { ReactElement, memo, useEffect, useState } from 'react';
import MaskedInput from 'react-maskedinput';
import { countryCodeConverterIso3ToIso2 } from '../../utils/countryCodeConverter';
import FlagItem from './FlagItem';
import { useStyles } from './styles';

import { RootState, AppDispatch } from '../../store/store';
import { fetchCountries } from '../../features/country/countryThunks';
import { getCountryDisplayName, setCountry } from '../../features/country/countrySlice';

interface IFormProps {
    onChange: (res: any) => void;
    name?: string;
    value?: string;
    code?: string;
}

const PhoneInput: React.FC<IFormProps> = ({ onChange, name, value }): ReactElement => {
    const classes = useStyles();
    const dispatch = useDispatch<AppDispatch>();
    const [anchorEl, setAnchorEl] = useState<HTMLElement>();

    const { countries, country: selectedCountry } = useSelector((state: RootState) => state.country);

    // Charger la liste des pays
    useEffect(() => {
        if (!countries.length) {
            dispatch(fetchCountries());
        }
    }, [dispatch, countries.length]);

    // Sélectionner automatiquement le premier pays si rien n’est sélectionné
    useEffect(() => {
        if (!selectedCountry?.code && countries.length) {
            dispatch(setCountry(countries[0]));
        }
    }, [countries, selectedCountry, dispatch]);

    const codeCountry: keyof typeof Flags =
        selectedCountry && countryCodeConverterIso3ToIso2.has(selectedCountry.code)
            ? countryCodeConverterIso3ToIso2.get(selectedCountry.code).toUpperCase()
            : 'FR';

    const FlagComponent: any = Flags[codeCountry];

    const handleOnChange = (res: any) => {
        
        const newRes = {
            ...res,                   
            target: {
                ...res?.target,          
                indicatif: selectedCountry?.indicatif, 
                name: name || 'phone',
                mask: res?.target?.getAttribute('mask'),
                country: getCountryDisplayName(selectedCountry),
                code: selectedCountry?.code
            },
        };
        
        onChange(newRes);
    };

    const handleCountryChange = (countryItem: any): any => {
        dispatch(setCountry(countryItem));
        setAnchorEl(undefined);
        onChange({
            target: {
                name: name || 'phone',
                value: value || '',
                indicatif: countryItem?.indicatif || '',
                mask: countryItem?.mask || '',
                country: getCountryDisplayName(countryItem),
                code: countryItem?.code || '',
            },
        });
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    minHeight: 40,
                    padding: '0px 6px',
                    borderRadius: 11,
                    border: '1px solid #cfd9e8',
                    boxShadow: 'none',
                    background: '#fff',
                    alignItems: 'center',
                    fontFamily: 'Gellix',
                    direction: 'ltr',
                }}
            >
                <div
                    data-testid="open-list-countries"
                    onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                    }}
                    style={
                        {
                            background: 'transparent',
                            borderRadius: 8,
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            minHeight: 36,
                            padding: '0 8px 0 4px',
                        }
                    }
                    role="presentation"
                >
                    <IconButton
                        className={classes.flagButton}
                        disableRipple
                        sx={{
                            '&:focus': { outline: 'none', boxShadow: 'none' },
                            '&:focus-visible': { outline: 'none', boxShadow: 'none' },
                        }}
                    >
                        {Boolean(FlagComponent) && (
                            <FlagComponent
                                className="margin"
                                style={{ margin: 0, width: 34, height: 25, display: 'block' }}
                            />
                        )}
                    </IconButton>
                    <span
                        style={{
                            width: 0,
                            height: 0,
                            borderLeft: '4px solid transparent',
                            borderRight: '4px solid transparent',
                            borderTop: '5px solid #6f7f98',
                            margin: '0 1px 0 0',
                            alignSelf: 'center',
                        }}
                    />
                    <p className={classes.stylePhone}>{selectedCountry?.indicatif}</p>
                </div>

                <Menu
                    id="country-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(undefined)}
                >
                    {React.Children.toArray(
                        countries?.map((item: any, key: any) => (
                            <FlagItem
                                testid={`item-countrie${key}`}
                                item={item}
                                handleCountryChange={handleCountryChange}
                            />
                        ))
                    )}
                </Menu>

                <MaskedInput
                    mask={selectedCountry?.mask || '1 11 11 11 11'}
                    type="tel"
                    placeholder=""
                    data-testid="phone-input"
                    id="my-input-id"
                    value={value}
                    name={name}
                    style={{
                        border: 'none',
                        fontSize: '15px',
                        margin: '0 0 0 10px',
                        outline: 'none',
                        boxShadow: 'none',
                        color: '#1A0244',
                        fontFamily: 'Gellix',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '20px',
                        direction: 'ltr',
                        order: 0,
                        width: '100%',
                    }}
                    onChange={(event: any) => handleOnChange(event)}
                />
            </div>
        </>
    );
};

export default memo(PhoneInput);
